import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { SubReasonService } from './sub-reason.service';

@Component({
  selector: 'app-sub-reason',
  templateUrl: './sub-reason.component.html',
  styleUrls: ['./sub-reason.component.scss']
})
export class SubReasonComponent implements OnInit {
bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo','sales_lost_reason', 'reason', 'reason_code', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  subReasonForm: FormGroup;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private subReasonService: SubReasonService) {
    this.subReasonForm = this.fb.group({
      reason: ['', Validators.required],
      postpond_reasons_id: ['', Validators.required],
      reason_code: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getSalesLostReasons();
  }

  get f() { return this.subReasonForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.subReasonForm.patchValue({
      reason: object.reason,
      reason_code: object.reason_code,
      postpond_reasons_id: object.postpond_reasons_id,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.subReasonForm.valid) {
      const reasonData = this.subReasonForm.value;
      let obj = {
        "reason": reasonData.reason,
        "reason_code": reasonData.reason_code,
        "postpond_reasons_id": parseInt(reasonData.postpond_reasons_id),
        "status": parseInt(reasonData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.subReasonService.subReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Sub reason created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.subReasonForm.valid) {
      const reasonData = this.subReasonForm.value;
      let obj = {
        "reason": reasonData.reason,
        "reason_code": reasonData.reason_code,
        "postpond_reasons_id": parseInt(reasonData.postpond_reasons_id),
        "status": parseInt(reasonData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.subReasonService.subReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Sub reason updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.subReasonForm.patchValue({
      reason: '',
      reason_code: '',
      postpond_reasons_id: '',
      status: ''
    });
  }

  allowAlphabetsSplcharsOnly(event: any) {
    this.sharedService.allowAlphabetsSplcharsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.subReasonService.subReasonCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  salesLostReasons:any = []
  getSalesLostReasons() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.subReasonService.getSalesReason(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.salesLostReasons = responseData.data
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

   public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const reason = data?.sales_lost_reason?.reason.toLowerCase().includes(filter);
      const sub_reason = data.reason.toLowerCase().includes(filter);
      const code = data.reason_code.toLowerCase().includes(filter);
      return reason || sub_reason || code;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
